import { useEffect, useState } from "react"
import { baseURL, socket } from "../../../api"
import { Character, GameItem, State } from "../../../types"
import AppModal from "../../Common/AppModal"
import { useDispatch, useSelector } from "react-redux"
import { closeWindow, openWindow } from "../../../actions"
import { Modal } from "react-bootstrap"
import { ItemEffect } from "../../../types/GameTypes"
import { statName } from "../../../helpers/gameHelpers"
import AppButton from "../../Common/AppButton"
import { equipSlotName, getItemsOnTheGround } from "../helpers/dataHelpers"

type Props = {
    character: Character
}
const Inventory: React.FC<Props> = (props) => {

    const dispatch: any = useDispatch()
    const [selectedItem, setSelectedItem] = useState<GameItem | null>(null);
    const [itemsOnTheGround, setItemsOnTheGround] = useState<GameItem[]>([]);
    // For items on the ground
    const gameInstance = useSelector((store: State) => store.gameInstance)
    const currentCharacterId = useSelector((store: State) => store.currentCharacterId)

    const openWindows = useSelector((store: State) => store.applicationStatus.openWindows)

    useEffect(() => {
        if (openWindows.includes("inventory")) {
            setItemsOnTheGround(getItemsOnTheGround(currentCharacterId ?? ""))
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [openWindows, gameInstance]);

    const onItemClick = (item: GameItem) => {
        setSelectedItem(item)
        dispatch(openWindow("itemOverlay"))
    }

    const openStats = () => {
        dispatch(openWindow("characterStats"))
    }

    // Equipped items
    const eq = {
        head: props.character.equipped.find(x => x.loca === "head"),
        body: props.character.equipped.find(x => x.loca === "body"),
        rightHand: props.character.equipped.find(x => x.loca === "rhand"),
        leftHand: props.character.equipped.find(x => x.loca === "lhand"),
    }

    return (
        props.character && <>
            <AppModal name="inventory" title="Inventory">
                <div className="p-2 position-relative">

                    {/* <p className="m-0">Equipped</p> */}
                    <div className="text-center" style={{position: "relative"}}>
                        <img src={`${baseURL}/img/ui/char_silhouette.png`} style={{height: "200px", opacity: .2, marginTop: "25px"}} alt="" />
                        {/* Head */}
                        <div className={`inv-item-slot ${eq.head && "clickable"}`} style={{position: "absolute", left: "calc(50% - 28px)", top: "0px"}} onClick={() => {eq.head && onItemClick(eq.head.item)}}>
                            {eq.head && <img src={`${baseURL}/${eq.head.item.img}`} style={{width: "50px", height: "50px"}} alt="" />}
                        </div>
                        {/* Body */}
                        <div className={`inv-item-slot ${eq.body && "clickable"}`} style={{position: "absolute", left: "calc(50% - 28px)", top: "55px"}} onClick={() => {eq.body && onItemClick(eq.body.item)}}>
                            {eq.body && <img src={`${baseURL}/${eq.body.item.img}`} style={{width: "50px", height: "50px"}} alt="" />}
                        </div>
                        {/* Right hand */}
                        <div className={`inv-item-slot ${eq.rightHand && "clickable"}`} style={{position: "absolute", left: "calc(50% - 83px)", top: "90px"}} onClick={() => {eq.rightHand && onItemClick(eq.rightHand.item)}}>
                            {eq.rightHand && <img src={`${baseURL}/${eq.rightHand.item.img}`} style={{width: "50px", height: "50px"}} alt="" />}
                        </div>
                        {/* Left hand */}
                        <div className={`inv-item-slot ${eq.leftHand && "clickable"}`} style={{position: "absolute", left: "calc(50% + 28px)", top: "90px"}}  onClick={() => {eq.leftHand && onItemClick(eq.leftHand.item)}}>
                            {eq.leftHand && <img src={`${baseURL}/${eq.leftHand.item.img}`} style={{width: "50px", height: "50px"}} alt="" />}
                        </div>
                    </div>
                        <AppButton style={{position: "absolute", top: "15px"}} variant="secondary" onClick={openStats}>Stats</AppButton>
                    <p className="m-0">Items</p>
                    <div>
                        {props.character.inventory.map(item => <Item key={item.id} item={item} onItemClick={onItemClick} />)}
                    </div>
                    <div style={{clear: "both"}}></div>
                    {itemsOnTheGround.length > 0 && <p className="m-0">Items on the ground</p>}
                    <div>
                        {itemsOnTheGround.map(item => <Item key={item.id} item={item} onItemClick={onItemClick} onGround />)}
                    </div>
                </div>
                <ItemOverlay item={selectedItem} set={setSelectedItem} character={props.character} />
                {/* <CharacterStats c={props.character} /> */}
            </AppModal>
        </>
    )
}

type ItemProps = {
    item: GameItem,
    onItemClick: (item: GameItem) => void,
    onGround?: boolean
}
const Item: React.FC<ItemProps> = (props) => {
    return (
        props.item && <>
            <div className="inv-item-slot clickable" onClick={() => { props.onItemClick(props.item) }}>
                <img src={`${baseURL}/${props.item.img}`} style={{width: "50px", height: "50px"}} alt="" />
            </div>
        </>
    )
}

type ItemOverlayProps = {
    item: GameItem | null,
    character: Character,
    set: React.Dispatch<React.SetStateAction<GameItem | null>>,
}
const ItemOverlay: React.FC<ItemOverlayProps> = (props) => {
    const dispatch: any = useDispatch();

    const equip = () => {
        props.item && socket.emit("equipItem", props.item.id)
        dispatch(closeWindow("itemOverlay"))
    }
    const use = () => {
        props.item && socket.emit("useItem", { itemId: props.item.id })
        dispatch(closeWindow("itemOverlay"))
    }
    const unEquip = () => {
        props.item && socket.emit("unEquipItem", props.item.id)
        dispatch(closeWindow("itemOverlay"))
    }
    const drop = () => {
        props.item && socket.emit("dropItem", props.item.id)
        dispatch(closeWindow("itemOverlay"))
    }
    const pickUp = () => {
        props.item && socket.emit("pickUpItem", props.item.id)
        dispatch(closeWindow("itemOverlay"))
    }

    const itemIsEquipped = props.character.equipped.find(i => i.item.id === props.item?.id) !== undefined
    const itemIsInInventory = props.character.inventory.find(i => i.id === props.item?.id) !== undefined
    const itemIsEquippable = !itemIsEquipped && props.item?.equip !== undefined

    return (
        <AppModal name="itemOverlay" title={props.item?.displayName ?? ""} onClose={() => { props.set(null) }} >
            <Modal.Body className="p-2">
                <div style={{height: "140px"}}>
                    <div className="text-description text-center pb-3">{props.item?.description}</div>
                    <div className="item-bg" style={{float: "left", marginRight: "10px"}}>
                        <img src={`${baseURL}/${props.item?.img}`} style={{width: "100px", height: "100px"}} alt="" />
                    </div>

                    {props.item?.effects.map((e, i) => <div key={i}><ItemEffectText e={e} /></div>)}

                    {props.item?.categories.includes("melee") && <div className="mt-3 text-description">Melee weapon; Add Strength test result to damage each hit</div>}
                </div>

                {props.item?.equip && <div className="text-description text-center pt-3">Equippable ({equipSlotName(props.item.equip)})</div>}

            </Modal.Body>
            <Modal.Footer className="p-1" style={{justifyContent: "center"}}>
                {(itemIsInInventory) && <AppButton className="" variant="secondary" onClick={drop}>Drop</AppButton>}
                {(itemIsEquippable && itemIsInInventory) && <AppButton className="" variant="secondary" onClick={equip}>Equip</AppButton>}
                {(props.item?.verb && itemIsInInventory) && <AppButton className="" variant="secondary" onClick={use}>{props.item.verb}</AppButton>}
                {(itemIsEquipped) && <AppButton className="" variant="secondary" onClick={unEquip}>Unequip</AppButton>}
                {(!itemIsEquipped && !itemIsInInventory) && <AppButton className="" variant="secondary" onClick={pickUp}>Pick up</AppButton>}
            </Modal.Footer>
        </AppModal>
    )
}

type ItemEffectTextProps = {
    e: ItemEffect,
}
const ItemEffectText: React.FC<ItemEffectTextProps> = (props) => {
    if (props.e.description) {
        return <>{props.e.description}</>
    }
    return <><strong>{statName(props.e.stat)}</strong> {props.e.amount >= 0 && "+"}{props.e.amount}</>
}

export default Inventory